import React from "react";
import toast from "react-hot-toast";
import { IoCheckmark } from "react-icons/io5";

const PoF = ({
  setScreen,
  country,
  houseNo,
  setHouseNo,
  houseAddress,
  setHouseAddress,
  houseLandmark,
  setHouseLandmark,
  city,
  setCity,
  state,
  setState,

  postalCode,
  setPostalCode,
}: any) => {
  const validateFields = (no: string, name: string, landmark: string) => {
    if (!no) {
      toast.error(`Kindly add the house number`);
      return false;
    }
    if (!name) {
      toast.error(`Kindly add the street address`);
      return false;
    }
    if (!landmark) {
      toast.error(`Kindly add the Landmark`);
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateFields(houseNo, houseAddress, houseLandmark)) {
      return;
    }
    setScreen(5);
  };
  return (
    <div className="w-full font-manrope">
      {/* Progress Steps */}
      <div className="flex w-full gap-2 justify-start items-center">
        <div className="w-[24px] h-[24px] rounded-full bg-[#0B6F18] font-sora text-white text-[10px] flex justify-center items-center">
          <IoCheckmark />
        </div>
        <div className="w-[24px] h-[24px] rounded-full border-[0.5px] border-[#0B75C2] bg-[#E9F1FF]  font-sora text-secondary_button text-[10px] flex justify-center items-center">
          2
        </div>
        <h4 className="text-[12px] text-black dark:text-white font-sora font-bold">
          Proof of Address
        </h4>
        <div className="bg-[#E5E7EB] dark:bg-gray-500 w-[2px] h-4 rounded-full"></div>

        <div className="w-[24px] h-[24px] rounded-full bg-[#EBEBEB] font-sora text-gray-600 dark:text-gray-400 dark:bg-gray-600 text-[10px] flex justify-center items-center">
          3
        </div>
      </div>

      {/* Title */}
      <div className="w-full mt-10">
        <h4 className="text-black dark:text-white text-center font-semibold font-sora text-[16px]">
          Home Address
        </h4>
        <h4 className="text-gray-400 text-center font-medium text-[12px]">
          Country: {country}
        </h4>

        {/* Document Selection */}
        <div className="mt-6 w-full">
          <div className="w-full ">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
              Apartment No
            </h4>
            <input
              type="text"
              placeholder="e.g: No 33"
              value={houseNo}
              onChange={(e) => setHouseNo(e.target.value)}
              className="bg-gray-50 border dark:bg-transparent text-gray-900 dark:text-gray-100 border-gray-500 rounded-xl h-[40px] px-4 outline-none text-[15px] mt-2 w-full"
            />
          </div>
          <div className="w-full mt-4">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
              Street Name
            </h4>
            <input
              type="text"
              placeholder="e.g Adeshina Street"
              value={houseAddress}
              onChange={(e) => setHouseAddress(e.target.value)}
              className="bg-gray-50 border dark:bg-transparent text-gray-900 dark:text-gray-100 border-gray-500 rounded-xl h-[40px] px-4 outline-none text-[15px] mt-2 w-full"
            />
          </div>
          <div className="w-full mt-4">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
              Landmark
            </h4>
            <input
              type="text"
              placeholder="e.g: Ifako-Ijaiye, Lagos State"
              value={houseLandmark}
              onChange={(e) => setHouseLandmark(e.target.value)}
              className="bg-gray-50 border dark:bg-transparent text-gray-900 dark:text-gray-100 border-gray-500 rounded-xl h-[40px] px-4 outline-none text-[15px] mt-2 w-full"
            />
          </div>
          <div className="w-full mt-4">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
              City
            </h4>
            <input
              type="text"
              placeholder="e.g: Ifako-Ijaiye"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="bg-gray-50 border dark:bg-transparent text-gray-900 dark:text-gray-100 border-gray-500 rounded-xl h-[40px] px-4 outline-none text-[15px] mt-2 w-full"
            />
          </div>
          <div className="w-full mt-4">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
              State
            </h4>
            <input
              type="text"
              placeholder="e.g: Ifako-Ijaiye"
              value={state}
              onChange={(e) => setState(e.target.value)}
              className="bg-gray-50 border dark:bg-transparent text-gray-900 dark:text-gray-100 border-gray-500 rounded-xl h-[40px] px-4 outline-none text-[15px] mt-2 w-full"
            />
          </div>
          <div className="w-full mt-4">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
              Postal Code
            </h4>
            <input
              type="text"
              placeholder="e.g: 12034"
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
              className="bg-gray-50 border dark:bg-transparent text-gray-900 dark:text-gray-100 border-gray-500 rounded-xl h-[40px] px-4 outline-none text-[15px] mt-2 w-full"
            />
          </div>
        </div>
      </div>

      {/* Next Button */}
      <button
        disabled={
          !houseAddress ||
          !houseNo ||
          !houseLandmark ||
          !city ||
          !state ||
          !postalCode
        }
        onClick={handleSubmit}
        className={
          !houseAddress ||
          !houseNo ||
          !houseLandmark ||
          !city ||
          !state ||
          !postalCode
            ? "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-gray-200 rounded-xl bg-gray-400"
            : "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
        }
      >
        Next
      </button>
    </div>
  );
};

export default PoF;
